/**
 * /heat-stress-calculator — страница: место, прогноз, часы, ручной режим, PDF.
 * Расчёт — в core.js (window.HeatStress); здесь только данные и разметка.
 * Прогноз — наш /api/weather/forecast (MET Norway + DWD, кэш по клетке ~1 км).
 */
(function () {
'use strict';

var CFG = window.__HS || {};
var T = CFG.t || {};
var SLUG = CFG.slug || 'heat-stress-calculator';
var COOL_REST = 20;           // WBGT прохладного помещения для отдыха, °C
var DAY_FROM = 5, DAY_TO = 21; // «рабочий день» для подсказки о лучших часах

var state = {
    loc: null, data: null, hours: [], day: 0, loading: false, reported: false,
    level: 'moderate', accl: 'yes', expo: 'sun', rest: 'shade', cloth: 'work',
    units: 'metric', manMode: 'weather',
};

function $(id) { return document.getElementById(id); }
function H() { return window.HeatStress; }

/* Подстановка «:имя» — длинные имена первыми, иначе «:h» съест «:hi». */
function t(k, r) {
    var s = T[k] != null ? String(T[k]) : k;
    if (!r) return s;
    Object.keys(r).sort(function (a, b) { return b.length - a.length; }).forEach(function (x) {
        s = s.split(':' + x).join(r[x]);
    });
    return s;
}
function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
}
function loc() { try { return window.__intlLocale ? window.__intlLocale() : (CFG.locale || 'en'); } catch (_) { return 'en'; } }

/* ── числа и единицы ───────────────────────────────────────────────────── */
var NF1 = null;
function n1(v) {
    if (!NF1) { try { NF1 = new Intl.NumberFormat(loc(), { minimumFractionDigits: 1, maximumFractionDigits: 1 }); } catch (_) { NF1 = { format: function (x) { return x.toFixed(1); } }; } }
    return NF1.format(v);
}
function imp() { return state.units === 'imperial'; }
function tVal(c) { return imp() ? c * 9 / 5 + 32 : c; }
/* Число с единицей — изолированный кусок слева направо: в арабском тексте
   без изоляции «28.0 °C» встаёт как «C° 28.0». */
var RTL = (document.documentElement.getAttribute('dir') || '') === 'rtl';
/* html2canvas рисует метки изоляции как мусор — на листе PDF их нет, а
   единицы стоят в заголовках колонок (ISO_OFF на время сборки листа). */
var ISO_OFF = false;
function iso(s) { return RTL && !ISO_OFF ? '\u2066' + s + '\u2069' : s; }
function tTxt(c) { return iso(n1(tVal(c)) + (imp() ? ' °F' : ' °C')); }
function dTxt(d) { return iso(n1(imp() ? d * 9 / 5 : d) + (imp() ? ' °F' : ' °C')); }
function tInC(v) { return imp() ? (v - 32) * 5 / 9 : v; }
function windInMs(v) { return imp() ? v * 0.44704 : v; }

/* ── время места, а не зрителя ─────────────────────────────────────────── */
function tz() { return (state.loc && state.loc.tz) || undefined; }
function parts(ms) {
    var o = {};
    try {
        new Intl.DateTimeFormat('en-GB', { timeZone: tz(), year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
            .formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = +p.value || 0; });
    } catch (_) {
        var d = new Date(ms);
        o = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(), hour: d.getHours(), minute: d.getMinutes() };
    }
    o.key = o.year * 10000 + o.month * 100 + o.day;
    return o;
}
function hm(ms) {
    try { return new Intl.DateTimeFormat(loc(), { timeZone: tz(), hour: '2-digit', minute: '2-digit' }).format(new Date(ms)); }
    catch (_) { var d = new Date(ms); return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0'); }
}
function dateTxt(ms, opts) {
    try { return new Intl.DateTimeFormat(loc(), Object.assign({ timeZone: tz() }, opts || { day: 'numeric', month: 'long' })).format(new Date(ms)); }
    catch (_) { var d = new Date(ms); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
}

/* ── настройки ─────────────────────────────────────────────────────────── */
function settingLoad(k, d) { try { return window.__toolSettings ? window.__toolSettings.load(SLUG, k, d) : d; } catch (_) { return d; } }
function settingSave(k, v) { try { if (window.__toolSettings) window.__toolSettings.save(SLUG, k, v); } catch (_) {} }

function bindSeg(id, key, onChange) {
    var box = $(id);
    if (!box) return;
    function paint() {
        box.querySelectorAll('[data-v]').forEach(function (b) {
            var on = b.dataset.v === String(state[key]);
            b.classList.toggle('on', on);
            b.setAttribute('aria-pressed', String(on));
        });
    }
    paint();
    box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-v]');
        if (!b || b.dataset.v === String(state[key])) return;
        state[key] = b.dataset.v;
        settingSave(key, state[key]);
        paint();
        if (onChange) onChange();
    });
}

/* ── расчёт часов ──────────────────────────────────────────────────────── */
function computeHours() {
    var d = state.data, out = [];
    if (!d || !d.hours) return out;
    d.hours.forEach(function (h) {
        if (h.span !== 1 || h.temp == null) return;
        var ms = Date.parse(h.t);
        var w = H().hourWbgt(h, d.lat, d.lon);
        var x = {
            ms: ms, p: parts(ms), temp: h.temp, rh: w.rh, wind: h.wind, sun: w.sun, shade: w.shade,
            elev: w.elev, hi: H().heatIndexC(h.temp, w.rh), kma: H().kmaFeels(h.temp, w.rh), range: null,
        };
        /* Две модели прогноза: держим точку росы и пересчитываем WBGT на
           нижней и верхней температуре — так расхождение моделей видно в
           том числе, в котором человек принимает решение. */
        if (h.tlo != null && h.thi != null && (h.spread || 0) >= 1) {
            var hold = function (tt) {
                return Object.assign({}, h, { temp: tt, hum: h.dew != null ? H().rhFromDew(tt, h.dew) : h.hum });
            };
            var lo = H().hourWbgt(hold(h.tlo), d.lat, d.lon), hi = H().hourWbgt(hold(h.thi), d.lat, d.lon);
            x.range = { sun: [lo.sun, hi.sun], shade: [lo.shade, hi.shade], d: h.spread };
        }
        out.push(x);
    });
    return out;
}

function workW(x) { return state.expo === 'sun' ? x.sun : x.shade; }
function restW(x, work) { return state.rest === 'same' ? work : state.rest === 'shade' ? x.shade : COOL_REST; }
function regime(x, accl) {
    var w = workW(x);
    return H().workRest(w, restW(x, w), state.level, accl, state.cloth);
}
function regimeKey(r) { return r.restUnsafe ? 'x' : String(Math.round(r.f * 100) === 100 ? 1 : Math.round(r.f * 100)); }
function regimeCls(r) { return 'hs-r' + regimeKey(r); }
function cc() { return (state.loc && state.loc.cc) || ''; }
function midday(x) { return H().middayBan(cc(), x.p.month, x.p.day, x.p.hour + x.p.minute / 60); }
function qaStop(x) { return !!(H().wbgtStop && H().wbgtStop(cc(), workW(x))); }
function banned(x) { return midday(x) || qaStop(x); }
function banNotes(x) {
    var n = [];
    if (midday(x)) n.push(t('note_ban'));
    if (qaStop(x)) n.push(t('note_qa_stop', { v: tTxt(H().QA_WBGT_STOP) }));
    return n;
}
function continuousLimit(accl) {
    return H().limitWbgt(H().MET[state.level], accl) - (H().CLOTHING[state.cloth] || 0);
}

function days() {
    var keys = [];
    state.hours.forEach(function (x) { if (keys.indexOf(x.p.key) < 0) keys.push(x.p.key); });
    return keys;
}
function hoursOfDay(i) {
    var k = days()[i];
    return state.hours.filter(function (x) { return x.p.key === k; });
}
function nowHour() {
    var now = Date.now(), best = state.hours[0] || null;
    state.hours.forEach(function (x) { if (x.ms <= now && now < x.ms + 3600000) best = x; });
    return best;
}

/* ── отрисовка ─────────────────────────────────────────────────────────── */
function renderAll() {
    if (!state.data) return;
    state.hours = computeHours();
    renderNow();
    renderDay();
    renderRules();
    renderManual();
}

function tag(r, short) {
    return '<span class="hs-tag ' + regimeCls(r) + '">' + esc(t((short ? 's_' : 'r_') + regimeKey(r))) + '</span>';
}

function renderNow() {
    var x = nowHour(), box = $('hsNow');
    if (!x) { box.innerHTML = '<p class="hs-empty">' + esc(t('err_load')) + '</p>'; return; }
    var accl = state.accl === 'yes';
    var r = regime(x, accl), other = regime(x, !accl);
    var w = workW(x);
    $('hsNowWhen').textContent = t('now_when', { time: hm(x.ms) });
    var lines = [];
    lines.push(t('line_limit', { v: tTxt(continuousLimit(accl)) }));
    lines.push('<b>' + esc(t(accl ? 'line_novice' : 'line_veteran')) + '</b> ' + esc(t('r_' + regimeKey(other))));
    if (x.range) {
        var rg = x.range[state.expo];
        lines.push(t('line_spread', { d: dTxt(x.range.d), lo: tTxt(rg[0]), hi: tTxt(rg[1]) }));
    }
    lines.push(t('line_hi', { hi: tTxt(x.hi) }));
    banNotes(x).reverse().forEach(function (n) { lines.unshift('<b>' + esc(n) + '</b>'); });
    box.innerHTML =
        '<div class="hs-now">' +
            '<div class="tc-answer">' +
                '<span class="tc-answer-l">' + esc(t(x.elev > 0 ? 'now_label_' + state.expo : 'now_label_night')) + '</span>' +
                '<span class="tc-answer-v">' + esc(n1(tVal(w))) + '<span class="u">' + (imp() ? ' °F' : ' °C') + '</span></span>' +
                '<p class="tc-answer-sub">' + esc(t('wbgt_sun_shade', { sun: tTxt(x.sun), shade: tTxt(x.shade), air: tTxt(x.temp), rh: Math.round(x.rh) })) + '</p>' +
            '</div>' +
            '<div class="' + regimeCls(r) + '">' +
                '<p class="hs-regime">' + esc(t('r_' + regimeKey(r))) + '</p>' +
                '<ul class="hs-lines">' + lines.map(function (l) { return '<li>' + (l.charAt(0) === '<' ? l : esc(l)) + '</li>'; }).join('') + '</ul>' +
            '</div>' +
        '</div>';
}

function ranges(list) {
    var out = [], start = null, prev = null;
    list.forEach(function (x) {
        var ok = x.p.hour >= DAY_FROM && x.p.hour < DAY_TO && regime(x, state.accl === 'yes').f === 1 && !banned(x);
        if (ok && start === null) start = x;
        if (!ok && start !== null) { out.push([start, prev]); start = null; }
        if (x.p.hour >= DAY_FROM && x.p.hour < DAY_TO) prev = x;
    });
    if (start !== null) out.push([start, prev]);
    return out;
}

function renderDay() {
    var list = hoursOfDay(state.day);
    var nDays = days().length;
    $('hsDayPanel').hidden = !list.length;
    $('hsDay').querySelectorAll('[data-v]').forEach(function (b) { b.disabled = +b.dataset.v >= nDays; });
    if (!list.length) return;
    var day = list.filter(function (x) { return x.p.hour >= DAY_FROM && x.p.hour < DAY_TO; });
    var rs = ranges(list);
    var best = $('hsBest');
    if (!day.length) best.textContent = t('day_over');
    else if (rs.length === 1 && rs[0][0] === day[0] && rs[0][1] === day[day.length - 1]) best.textContent = t('best_all');
    else if (!rs.length) best.textContent = t('best_none');
    else best.textContent = t('best_some', { ranges: rs.map(function (r) { return hm(r[0].ms) + '–' + hm(r[1].ms + 3600000); }).join(', ') });

    var now = nowHour();
    var accl = state.accl === 'yes';
    var bars = '', axis = '', rows = '';
    list.forEach(function (x, i) {
        var r = regime(x, accl), w = workW(x), ban = banned(x);
        var hgt = Math.max(4, Math.min(100, (w - 5) / (38 - 5) * 100));
        bars += '<div class="hs-bar ' + regimeCls(r) + (x === now ? ' now' : '') + (ban ? ' ban' : '') + '" style="height:' + hgt.toFixed(0) + '%" title="' + esc(hm(x.ms) + ' · ' + tTxt(w) + ' · ' + t('s_' + regimeKey(r))) + '"></div>';
        axis += '<span>' + (i % 3 === 0 ? esc(String(x.p.hour).padStart(2, '0')) : '') + '</span>';
        var notes = banNotes(x);
        if (cc() === 'KR') { if (x.kma >= 33) notes.push(t('note_kr33', { v: tTxt(x.kma) })); else if (x.kma >= 31) notes.push(t('note_kr31', { v: tTxt(x.kma) })); }
        var other = regime(x, !accl);
        rows += '<tr class="' + (x === now ? 'now ' : '') + (ban ? 'ban' : '') + '">' +
            '<td class="hs-t">' + esc(hm(x.ms)) + '</td>' +
            '<td class="hs-wide num">' + esc(tTxt(x.temp)) + '<span class="hs-sm">' + Math.round(x.rh) + ' %</span></td>' +
            '<td class="num"><b>' + esc(tTxt(w)) + '</b><span class="hs-sm">' + esc(t(state.expo === 'sun' ? 'expo_shade' : 'expo_sun') + ' ' + tTxt(state.expo === 'sun' ? x.shade : x.sun)) + '</span></td>' +
            '<td>' + tag(r, true) + '<span class="hs-sm">' + esc(t(accl ? 'th_novice' : 'accl_yes') + ': ' + t('s_' + regimeKey(other))) + '</span></td>' +
            '<td class="hs-wide hs-note">' + esc(notes.join(' · ')) + '</td>' +
            '</tr>';
    });
    $('hsBars').innerHTML = bars;
    $('hsAxis').innerHTML = axis;
    $('hsRows').innerHTML = rows;
}

function countryName(code) {
    try { return new Intl.DisplayNames([loc()], { type: 'region' }).of(code) || code; } catch (_) { return code; }
}

/* forSheet — лист PDF на выбранный день: правило страны без строки «сейчас»
   (значение по часам стоит в таблице листа). На арабском листе нет абзаца с
   формулой: html2canvas делит латинский кусок внутри арабского абзаца на слова
   и ставит каждое со сдвигом на пробел (замер 21.10 на двух версиях двери PDF) —
   формула выходила задом наперёд или внахлёст. На странице она есть. */
function rulesHtml(forSheet) {
    var p = forSheet && RTL ? [] : ['<p>' + esc(t('rules_method')) + '</p>'];
    var c = cc(), x = nowHour();
    if (c === 'RU' && x) {
        var s = H().soutClass(workW(x), state.level);
        p.push('<p>' + esc(t('rules_ru')) + (forSheet ? '' : ' ' + esc(t('rules_ru_now', { cat: s.cat.replace('a', 'а').replace('b', 'б'), cls: s.cls }))) + '</p>');
    } else if (c === 'KR' && x) {
        p.push('<p>' + esc(t('rules_kr')) + (forSheet ? '' : ' ' + esc(t('rules_kr_now', { v: tTxt(x.kma) }))) + '</p>');
    } else if (H().MIDDAY_BAN[c]) {
        var r = H().MIDDAY_BAN[c], y = new Date().getFullYear();
        var md = function (m, d) { return dateTxt(Date.UTC(y, m - 1, d, 12), { day: 'numeric', month: 'long', timeZone: 'UTC' }); };
        var hh = function (v) { return String(Math.floor(v)).padStart(2, '0') + ':' + (v % 1 ? '30' : '00'); };
        p.push('<p>' + esc(t('rules_gulf', { country: countryName(c), from: md(r.from[0], r.from[1]), to: md(r.to[0], r.to[1]), h1: hh(r.h[0]), h2: hh(r.h[1]) })) + '</p>');
        if (c === 'QA') p.push('<p>' + esc(t('rules_qa_wbgt', { v: tTxt(H().QA_WBGT_STOP) })) + '</p>');
    } else if (c === 'US') p.push('<p>' + esc(t('rules_us')) + '</p>');
    else if (c === 'GB') p.push('<p>' + esc(t('rules_gb')) + '</p>');
    else if (c === 'AU') p.push('<p>' + esc(t('rules_au')) + '</p>');
    else if (c === 'BR') p.push('<p>' + esc(t('rules_br')) + '</p>');
    else if (c) p.push('<p>' + esc(t('rules_other')) + '</p>');
    return p.join('');
}
function renderRules() { $('hsRules').innerHTML = rulesHtml(); }

/* ── ручной режим: цех, кабина, свой прибор ────────────────────────────── */
var MAN_SUN = { none: 0, overcast: 200, partly: 550, clear: 900 };
function renderManual() {
    var out = $('hsManOut');
    if (!out || !$('hsManual').open) return;
    var accl = state.accl === 'yes', w, shade;
    if (state.manMode === 'meter') {
        w = tInC(parseFloat(String($('hsManW').value).replace(',', '.')));
        if (!isFinite(w)) { out.hidden = true; return; }
        shade = w;
    } else {
        var ta = tInC(parseFloat(String($('hsManT').value).replace(',', '.')));
        var rh = parseFloat(String($('hsManRh').value).replace(',', '.'));
        var va = windInMs(parseFloat(String($('hsManWind').value).replace(',', '.')));
        if (!isFinite(ta) || !isFinite(rh) || rh <= 0) { out.hidden = true; return; }
        if (!isFinite(va)) va = 0.5;
        var cza = 0.87, ghi = MAN_SUN[$('hsManSun').value] || 0;
        var sp = H().solarParams(ghi, cza, 1);
        var base = { ta: ta, rh: Math.min(100, rh), p: 1013.25, va2: va, cza: cza };
        w = H().wbgtLiljegren(Object.assign({}, base, { solar: sp.solar, fdir: sp.fdir })).wbgt;
        shade = H().wbgtLiljegren(Object.assign({}, base, { solar: sp.solar * (1 - sp.fdir), fdir: 0 })).wbgt;
    }
    var rest = state.rest === 'cool' ? COOL_REST : state.rest === 'shade' ? shade : w;
    var r = H().workRest(w, rest, state.level, accl, state.cloth);
    out.hidden = false;
    out.innerHTML = '<div class="' + regimeCls(r) + '"><p class="tc-answer-sub">' + esc(t('man_result', { w: tTxt(w) })) + '</p>' +
        '<p class="hs-regime">' + esc(t('r_' + regimeKey(r))) + '</p>' +
        '<p class="tc-answer-note">' + esc(t('line_limit', { v: tTxt(continuousLimit(accl)) })) + '</p>' +
        (state.manMode === 'meter' ? '<p class="tc-answer-note">' + esc(t('man_meter_note')) + '</p>' : '') + '</div>';
}

/* ── PDF и печать для планёрки ─────────────────────────────────────────── */
var SW = { 'hs-r1': '#2e9d5b', 'hs-r75': '#c9a227', 'hs-r50': '#e0a020', 'hs-r25': '#e2662b', 'hs-r0': '#d23a3a', 'hs-rx': '#a855f7' };
/* Лист живёт в #hsPrintHost: один и тот же узел уходит в PDF и на печать. */
/* Источники на арабском листе — одной строкой имён, склеенной неразрывными
   пробелами: один кусок без арабских букв дверь рисует слева направо целиком. */
var CITE_RTL = ['MET Norway', 'DWD', 'CC BY 4.0', 'WBGT: Liljegren 2008', 'NIOSH 2016']
    .map(function (x) { return x.replace(/ /g, '\u00a0'); }).join('\u00a0·\u00a0');
function sheet() {
    var list = hoursOfDay(state.day);
    if (!list.length) return null;
    ISO_OFF = true;
    try {
        var accl = state.accl === 'yes', u = imp() ? '°F' : '°C';
        var num = function (c) { return esc(n1(tVal(c))); }, sep = RTL ? '<br>' : ', ';
        var el = document.createElement('div');
        el.className = 'hs-sheet';
        el.setAttribute('dir', RTL ? 'rtl' : 'ltr');
        var rows = list.map(function (x) {
            var r = regime(x, accl), o = regime(x, !accl), notes = banNotes(x);
            if (cc() === 'KR' && x.kma >= 31) notes.push(t(x.kma >= 33 ? 'note_kr33' : 'note_kr31', { v: tTxt(x.kma) }));
            return '<tr><td>' + esc(hm(x.ms)) + '</td><td>' + num(x.temp) + '</td><td>' + Math.round(x.rh) + '</td><td><b>' + num(workW(x)) + '</b></td>' +
                '<td><span class="sw" style="background:' + SW[regimeCls(r)] + '"></span>' + esc(t('s_' + regimeKey(r))) + '</td><td>' + esc(t('s_' + regimeKey(o))) + '</td><td>' + esc(notes.join(' · ')) + '</td></tr>';
        }).join('');
        var place = (state.loc && state.loc.name) || (state.data.lat + ', ' + state.data.lon);
        el.innerHTML = '<h2>' + esc(t('sheet_title', { date: dateTxt(list[0].ms, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) })) + '</h2>' +
            '<p>' + esc(t('sheet_place', { place: place })) + '</p>' +
            '<p>' + esc(t('sheet_work', { level: t('level_' + state.level), expo: t('expo_' + state.expo), rest: t('rest_' + state.rest), cloth: t('cloth_' + state.cloth), accl: t(accl ? 'accl_yes' : 'accl_no') })) + '</p>' +
            '<table><thead><tr><th>' + esc(t('th_time')) + '</th><th>' + esc(t('th_air')) + sep + u + '</th><th>%</th><th>' + esc(t('th_wbgt')) + sep + u + '</th><th>' + esc(t('th_regime')) + '</th><th>' + esc(t('th_novice')) + '</th><th>' + esc(t('th_note')) + '</th></tr></thead><tbody>' + rows + '</tbody></table>' +
            '<p><b>' + esc(t('best_label')) + '</b> ' + esc($('hsBest').textContent) + '</p>' +
            rulesHtml(true) +
            '<p>' + esc(t('disclaimer')) + '</p>' +
            (RTL ? '<p dir="ltr">' + CITE_RTL + '</p>' : '<p>' + esc(t('sheet_source')) + '</p>') + '<p>' + esc(t('sheet_generated', { when: dateTxt(Date.now(), { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' }) })) + '</p>';
        var host = $('hsPrintHost');
        host.innerHTML = '';
        host.appendChild(el);
        return el;
    } finally { ISO_OFF = false; }
}

function savePdf() {
    var el = sheet();
    if (!el || !window.__generatePDF) { if (window.__toast) window.__toast(t('pdf_error'), 'error'); return; }
    var k = days()[state.day] || 0;
    window.__generatePDF({
        element: el,
        filename: 'heat-stress-' + String(k).replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') + '.pdf',
        orientation: 'portrait',
        strings: { genError: t('pdf_error'), libError: t('pdf_error') },
    }).then(function (res) {
        if (res && res.ok && window.__aeFunnel) window.__aeFunnel('pdf');
    });
}
function printSheet() {
    if (!sheet()) return;
    try { window.print(); } catch (_) {}
}

/* ── место и прогноз ───────────────────────────────────────────────────── */
function setStatus(txt, err) {
    var s = $('hsStatus');
    s.hidden = !txt;
    s.textContent = txt || '';
    s.classList.toggle('err', !!err);
}

function fillMeta(l) {
    if (l.tz && l.cc && l.name) return Promise.resolve(l);
    if (!window.LocationInput || !window.LocationInput.loadData) return Promise.resolve(l);
    return window.LocationInput.loadData().then(function () {
        var near = window.LocationInput.nearestByCoords(l.lat, l.lng);
        if (near) {
            if (!l.tz) l.tz = near.tz || '';
            if (!l.cc) l.cc = near.cc || '';
            if (!l.name) l.name = near.name || '';
        }
        return l;
    }).catch(function () { return l; });
}

function load(l) {
    if (state.loading || !l || !isFinite(l.lat) || !isFinite(l.lng)) return;
    state.loading = true;
    state.loc = l;
    $('hsPlace').textContent = l.name || (l.lat.toFixed(2) + ', ' + l.lng.toFixed(2));
    setStatus(t('loading'));
    if (window.__stage) window.__stage('fetch');
    var url = CFG.api + '?lat=' + encodeURIComponent(l.lat.toFixed(4)) + '&lon=' + encodeURIComponent(l.lng.toFixed(4));
    fetch(url, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) {
            if (!j || j.err || !j.hours || !j.hours.length) throw new Error(j && j.err ? j.err : 'empty');
            state.data = j;
            state.day = 0;
            paintDaySeg();
            renderAll();
            setStatus(j.stale ? t('stale') : '');
            settingSave('place', { lat: l.lat, lng: l.lng, name: l.name || '', tz: l.tz || '', cc: l.cc || '' });
            if (window.__stage) window.__stage('shown');
            if (!state.reported && window.__aeToolComplete) {
                state.reported = true;
                window.__aeToolComplete({ cc: l.cc || '', level: state.level, models: (j.models || []).join('+') });
            }
        })
        .catch(function (e) {
            setStatus(t('err_load'), true);
            if (window.__aeDiagnostic) window.__aeDiagnostic({ issue: 'fetch_failed', detail: String(e && e.message || e).slice(0, 120) });
        })
        .then(function () { state.loading = false; });
}

function initPicker() {
    var host = $('hsPicker');
    if (!host || host.dataset.mounted || !window.LocationInput) return;
    host.dataset.mounted = '1';
    window.LocationInput.mount(host, {
        tool: SLUG, t: CFG.li || {}, defaultTab: 'city',
        initial: state.loc ? { lat: state.loc.lat, lng: state.loc.lng, tz: state.loc.tz, cityName: state.loc.name } : undefined,
        onChange: function (c) {
            if (!c || !isFinite(c.lat) || !isFinite(c.lng) || c.source === 'profile') return;
            closePicker();
            fillMeta({ lat: c.lat, lng: c.lng, name: c.cityName || '', tz: c.tz || '', cc: '' }).then(load);
        },
    });
}
function openPicker() {
    $('hsPickerWrap').hidden = false;
    $('hsChange').setAttribute('aria-expanded', 'true');
    initPicker();
    var inp = $('hsPickerWrap').querySelector('input[type=text],input[type=search]');
    if (inp) inp.focus({ preventScroll: true });
}
function closePicker() {
    $('hsPickerWrap').hidden = true;
    $('hsChange').setAttribute('aria-expanded', 'false');
}

function useGeo() {
    if (!navigator.geolocation) { if (window.__geo) window.__geo.notify('no_api'); return; }
    var btn = $('hsGeo');
    btn.classList.add('busy');
    navigator.geolocation.getCurrentPosition(function (pos) {
        btn.classList.remove('busy');
        fillMeta({ lat: pos.coords.latitude, lng: pos.coords.longitude, name: '', tz: '', cc: '' }).then(load);
    }, function (err) {
        btn.classList.remove('busy');
        if (window.__geo) window.__geo.notify(err); else setStatus(t('geo_denied'), true);
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
}

function fromUrl() {
    try {
        var q = new URLSearchParams(location.search);
        var lat = parseFloat(q.get('lat')), lng = parseFloat(q.get('lon') || q.get('lng'));
        if (isFinite(lat) && isFinite(lng)) return { lat: lat, lng: lng, name: q.get('name') || '', tz: '', cc: '' };
    } catch (_) {}
    return null;
}
function fromProfile() {
    var u = window.__USER_LOCATION;
    return u && isFinite(u.lat) && isFinite(u.lng) ? { lat: u.lat, lng: u.lng, name: u.cityName || '', tz: u.tz || '', cc: '' } : null;
}

function paintDaySeg() {
    $('hsDay').querySelectorAll('[data-v]').forEach(function (b) {
        var on = +b.dataset.v === state.day;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', String(on));
    });
}

function paintUnits() {
    $('hsUnits').querySelectorAll('[data-u]').forEach(function (b) {
        var on = b.dataset.u === state.units;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', String(on));
    });
    $('hsManTL').textContent = t('man_temp') + (imp() ? ', °F' : ', °C');
    $('hsManWL').textContent = t('man_wbgt') + (imp() ? ', °F' : ', °C');
    $('hsManWindL').textContent = t('man_wind') + ', ' + t(imp() ? 'u_mph' : 'u_ms');
}

function levelHint() { $('hsLevelHint').textContent = t('level_hint_' + state.level); }

function init() {
    if (!window.HeatStress) return;
    ['level', 'accl', 'expo', 'rest', 'cloth'].forEach(function (k) {
        var v = settingLoad(k, null);
        if (v != null) state[k] = String(v);
    });
    try { state.units = window.__toolSettings ? window.__toolSettings.units() : 'metric'; } catch (_) {}
    if (['light', 'moderate', 'heavy', 'vheavy'].indexOf(state.level) < 0) state.level = 'moderate';

    var refresh = function () { levelHint(); renderAll(); };
    bindSeg('hsLevel', 'level', refresh);
    bindSeg('hsAccl', 'accl', refresh);
    bindSeg('hsExpo', 'expo', refresh);
    bindSeg('hsManMode', 'manMode', function () {
        $('hsManWeather').hidden = state.manMode !== 'weather';
        $('hsManMeter').hidden = state.manMode !== 'meter';
        renderManual();
    });
    [['hsRest', 'rest'], ['hsCloth', 'cloth']].forEach(function (p) {
        var el = $(p[0]);
        if (el.querySelector('option[value="' + state[p[1]] + '"]')) el.value = state[p[1]];
        else state[p[1]] = el.value;
        el.addEventListener('change', function () { state[p[1]] = el.value; settingSave(p[1], el.value); renderAll(); });
    });
    levelHint();
    paintUnits();

    $('hsUnits').addEventListener('click', function (e) {
        var b = e.target.closest('[data-u]');
        if (!b || b.dataset.u === state.units) return;
        state.units = b.dataset.u;
        try { if (window.__toolSettings && window.__toolSettings.setUnits) window.__toolSettings.setUnits(state.units); } catch (_) {}
        NF1 = null;
        paintUnits();
        renderAll();
    });
    $('hsDay').addEventListener('click', function (e) {
        var b = e.target.closest('[data-v]');
        if (!b || b.disabled || +b.dataset.v === state.day) return;
        state.day = +b.dataset.v;
        paintDaySeg();
        renderDay();
    });
    $('hsChange').addEventListener('click', function () { if ($('hsPickerWrap').hidden) openPicker(); else closePicker(); });
    $('hsGeo').addEventListener('click', useGeo);
    $('hsPdf').addEventListener('click', savePdf);
    $('hsPrint').addEventListener('click', printSheet);
    $('hsManual').addEventListener('toggle', renderManual);
    ['hsManT', 'hsManRh', 'hsManWind', 'hsManSun', 'hsManW'].forEach(function (id) {
        $(id).addEventListener('input', renderManual);
        $(id).addEventListener('change', renderManual);
    });

    var l = fromUrl() || settingLoad('place', null) || fromProfile();
    if (l && isFinite(l.lat) && isFinite(l.lng)) fillMeta(l).then(load);
    else openPicker();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
})();
